module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-06-86cebd7ae920ba874ad33ad34a2339b8.jpg";